module.exports = __webpack_public_path__ + "static/img/ios_bn.3a545cec.png";